import React from "react";
import s from "./DotLoader.module.css";

export const DotLoader = () => (
  <div className={s["dots-loader"]}>
    <span></span>
    <span></span>
    <span></span>
  </div>
);
